import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useDispatch, useSelector } from "react-redux";
import TopSection from "../../LT/TopSection";
import DataTable from '../../../components/common/datatable/DataTable';
import { getUserSupportTicketSummary } from '../../../redux/actions/getUserSupportTicketSummarySlice';
import { getUserSupportTicketByUser } from '../../../common/endpoints';
import { Loader } from '../../../components/common/Loader';
import { LTTicketSummaryTableHeaders } from './TicketSummaryHeader';
const TicketSummary = () => {
    const userEmail = localStorage.getItem("data")
    const dispatch = useDispatch();
    const loading = useSelector((state) => state?.getUserSupportTicketSummary?.loading);
    const [rowData, setRowData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const gridRef = useRef();
    const currentPageRef = useRef(0);
    const [gridApi, setGridApi] = useState();

    const pagination = true;
    const paginationPageSize = 10;
    const paginationPageSizeSelector = [10, 20, 30, 50, 100];

    const onGridReady = (params) => {
        setGridApi(params?.api);
        gridRef.current = params?.api;
        setSelectedRows([])
    }

    const onSelectionChanged = (params) => {
        const filteredSelectedRows = [];
        params?.api?.forEachNodeAfterFilter((node) => {
            if (node.isSelected()) {
                filteredSelectedRows.push(node.data);
            }
        });
        setSelectedRows(filteredSelectedRows);
    }
{/*}
    const rowSelection = useMemo(() => {
        return {
            mode: 'multiRow',
            isRowSelectable: (rowNode) => rowNode?.data?.status !== "RESOLVED",
        }
    })
*/}
    const gridOptions = {
        overlayLoadingTemplate: `<span class="ag--overlay-loading-center" >Please wait while data is loading</span>`,
        overlayNoRowsTemplate: `<span class="ag--overlay-no-rows-center" >No Data Available</span>`,
        defaultColDef: {
            sortable: true,
            filter: 'agMultiColumnFilter',
            filterParams: {
                filters: [
                    {
                        filter: 'agTextColumnFilter',
                        filterParams: {
                            suppressMiniFilter: false,
                        },
                    },
                    {
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            excelMode: 'windows',
                            suppressMiniFilter: false,
                            buttons: ['apply', 'reset'],
                        },
                    },
                ],
            },
            autoHeight: true,
            cellStyle: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: 1.5,
                display: "flex",
                alignItems: "center",
            },
            valueGetter: (params) => {
                if (!params.data) return "N/A";

                const field = params.colDef.field;
                const value = params.data[field];

                return value === null || value === undefined || value === "" ? "N/A" : value;
            },
        },
    }
    const onPaginationChanged = () => {
        if (gridRef.current && !gridRef.current.isDestroyed()) {
            const currentPage = gridRef.current.paginationGetCurrentPage();
            currentPageRef.current = currentPageRef.current || currentPage;
        }
    };
    const onFirstDataRendered = () => {
        if (gridRef.current && !gridRef.current.isDestroyed()) {
            gridRef.current.paginationGoToPage(currentPageRef.current || 0);
        }
    };
    const getRowHeight = (params) => {
        return params.api.getDisplayedRowAtIndex(params.node.rowIndex).rowHeight;
    };

    const getWorkFlowData = async () => {
        try {
            if (!userEmail) {
                setRowData([]);
                return;
            }

            const responseTicketSummary = await dispatch(getUserSupportTicketSummary({
                dynamicEndpoint: `${getUserSupportTicketByUser}/${encodeURIComponent(userEmail)}`
            }));

            if (responseTicketSummary?.meta?.requestStatus === 'fulfilled') {
                gridApi?.deselectAll();
                setRowData(Array.isArray(responseTicketSummary?.payload) ? responseTicketSummary.payload : []);
            } else {
                console.error('Failed to fetch data:', responseTicketSummary?.error);
            }
        } catch (error) {
            console.error('API error:', error);
        }
    }


    useEffect(() => {
        getWorkFlowData();
    }, [])

    return (
        loading ?
            <Loader />
            :
            <div>
                <TopSection
                    labelList={[
                        { title: "Dashboard", path: "/dashboard" },
                        { title: "Ticket Summary" },
                    ]}
                    tabTitle="Ticket Summary"
                    hideHeader={true}
                />
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <div>
                        {rowData && <DataTable
                            height="400px"
                            ref={gridRef}
                            columns={LTTicketSummaryTableHeaders}
                            rows={rowData || []}
                            paginationProp={pagination}
                            paginationPageSize={paginationPageSize}
                            paginationPageSizeSelector={paginationPageSizeSelector}
                            onGridReady={onGridReady}
                            onSelectionChanged={onSelectionChanged}
                          //  headerCheckboxSelectionFilterOnly={true}
                         //   rowSelection={rowSelection}
                            gridOptions={gridOptions}
                            getRowHeight={getRowHeight}
                            onPaginationChanged={onPaginationChanged}
                            onFirstDataRendered={onFirstDataRendered}
                        />}
                    </div>
                </div>
                <div style={{ margin: '20px 0px', display: 'flex', gap: 10, justifyContent: "end", alignItems: 'center' }}>
                   
                </div>
            </div>
    )
}

export default TicketSummary;